
<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('uom_list')}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <button class="btn btn-outline-primary btn-sm no-bor" @click="newHandler">
                <i class="fa fa-plus-circle"></i> {{$t('new')}}
            </button>
        </div>
        <div class="x_body">
            <div class="card n_card no-bor">
                <div class="card-body" style="padding: 0;">
                    <table class="table table-bordered table-sm no-bor" style="overflow-x: scroll">
                        <thead>
                        <tr>
                            <th class="text-center" style="width: 50px;">{{ $t('no') }}</th>
                            <th>{{ $t('uom_code')}}</th>
                            <th>{{ $t('uom_name') }}</th>
                            <th>{{ $t('uom_name_en')}}</th>
                            <th>{{ $t('description') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(ret, index) in records" :key="index">
                            <td class="text-center">{{index+1}}</td>
                            <td>{{ret.Code}}</td>
                            <td><a href="javascript:void(0)" @click="editHandler(ret)">{{ret.Name}}</a></td>
                            <td>{{ret.NameEn}}</td>
                            <td>{{ret.Description}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <FormModal ref="form" v-on:done="doneHandler" :value="edit" :isUpdate="isedit"/>
    </div>
</template>
<script>
    import Swal from "sweetalert2";
    import FormModal from "./Form.vue";
    export default {
        props: {},
        components: { FormModal },
        data: function() {
            return {
                query: {
                    currentPage: 1,
                    total: 0,
                    limit: 10
                },
                records: [],
                edit: null,
                isedit: false
            };
        },
        created: function() {
            this.init();
        },
        methods: {
            init: function() {
                var loading = this.$loading.show();
                this.$api().post('uom', {}).then(res => {
                    if (this.$isValid(res)) {
                        this.records = res.data.Data;
                    }
                }).finally(function(){ loading.hide(); });
            },
            newHandler: function(){
                this.isedit = false;
                this.edit = null;
                this.$refs.form.$refs.innermodal.show();
            },
            editHandler: function(item) {
                this.isedit = true;
                this.edit = JSON.parse(JSON.stringify(item));
                this.$refs.form.$refs.innermodal.show();
            },
            deleteHandler: function(id) {
                Swal.fire({
                    title: "Are you sure?",
                    text: "You will not be able to recover this uom!",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes, delete it!",
                    cancelButtonText: "No, keep it",
                }).then(result => {
                    if (result.value) {
                        this.dbRemove(id);
                    }
                });
            },
            dbRemove: function(id){
                var loading = this.$loading.show();
                this.$api().post("uom/delete", { Id: id }).then(res => {
                    if (this.$isValid(res)) {
                        Swal.fire(
                            "Deleted!",
                            "Your file has been deleted.",
                            "success"
                        );
                        this.init();
                    }
                }).finally(function(){ loading.hide(); });
            },
            doneHandler: function() {
                this.init();
            }
        }
    };
</script>
